<div class="privacy-page">
  <header class="hero">
    <h1>Política de Privacidad</h1>
    <p>Chevron IPCMS</p>
  </header>

  <main class="container">
    <div class="card">
      <div class="updated">Última actualización: 4 de junio de 2026</div>

      <section>
        <h2>1. Introducción</h2>
        <p>
          Chevron IPCMS es una aplicación destinada a la gestión de
          inspecciones, seguimiento operativo y administración de planes de
          tratamiento.
        </p>
        <p>
          Esta Política de Privacidad describe cómo recopilamos, utilizamos,
          almacenamos y protegemos la información procesada a través de la
          aplicación.
        </p>
      </section>

      <section>
        <h2>2. Información que recopilamos</h2>

        <h3>Información de autenticación</h3>
        <ul>
          <li>Identificador de usuario.</li>
          <li>Tokens de autenticación y sesión.</li>
          <li>Preferencias de acceso.</li>
        </ul>

        <h3>Información operativa</h3>
        <ul>
          <li>Inspecciones realizadas.</li>
          <li>Observaciones registradas.</li>
          <li>Archivos y fotografías asociadas.</li>
          <li>Planes de tratamiento y seguimiento.</li>
        </ul>

        <h3>Información técnica</h3>
        <ul>
          <li>Estado de conectividad.</li>
          <li>Datos necesarios para sincronización.</li>
          <li>Token de notificaciones push.</li>
        </ul>

        <h3>Preferencias del usuario</h3>
        <ul>
          <li>Idioma seleccionado.</li>
          <li>Configuración visual.</li>
          <li>Preferencias de sincronización.</li>
          <li>Configuración biométrica.</li>
        </ul>
      </section>

      <section>
        <h2>3. Permisos utilizados</h2>

        <h3>Cámara</h3>
        <p>
          Se utiliza exclusivamente para escanear códigos QR y capturar imágenes
          relacionadas con las inspecciones y tareas operativas.
        </p>

        <h3>Notificaciones</h3>
        <p>
          Se utilizan para informar eventos relevantes, actualizaciones y
          acciones importantes dentro de la aplicación.
        </p>

        <h3>Autenticación biométrica</h3>
        <p>
          La aplicación puede utilizar mecanismos biométricos del dispositivo
          para reforzar la seguridad de acceso cuando el usuario así lo
          habilite.
        </p>

        <div class="highlight">
          La aplicación no almacena huellas digitales, reconocimiento facial ni
          ningún dato biométrico. La validación es realizada por el sistema
          operativo del dispositivo.
        </div>
      </section>

      <section>
        <h2>4. Almacenamiento local</h2>
        <p>
          Parte de la información puede almacenarse localmente para permitir el
          funcionamiento sin conexión y mejorar el rendimiento de la aplicación.
        </p>
      </section>

      <section>
        <h2>5. Compartición de información</h2>
        <p>
          No vendemos ni compartimos información personal con terceros para
          fines comerciales.
        </p>

        <p>
          La información puede ser transmitida únicamente a sistemas
          corporativos necesarios para el funcionamiento de la aplicación y a
          proveedores tecnológicos utilizados para el envío de notificaciones.
        </p>
      </section>

      <section>
        <h2>6. Seguridad</h2>
        <p>
          Implementamos medidas técnicas y organizativas razonables para
          proteger la información procesada por la aplicación.
        </p>

        <p>
          Sin embargo, ningún método de almacenamiento o transmisión electrónica
          puede garantizar una seguridad absoluta.
        </p>
      </section>

      <section>
        <h2>7. Conservación de datos</h2>
        <p>
          Los datos serán conservados únicamente durante el tiempo necesario
          para cumplir los fines operativos y de seguridad de la aplicación.
        </p>
      </section>

      <section>
        <h2>8. Derechos del usuario</h2>
        <ul>
          <li>Solicitar acceso a sus datos.</li>
          <li>Solicitar correcciones.</li>
          <li>Solicitar eliminación cuando corresponda.</li>
          <li>Revocar permisos otorgados a la aplicación.</li>
        </ul>
      </section>

      <section>
        <h2>9. Cambios a esta política</h2>
        <p>
          Esta Política de Privacidad podrá actualizarse periódicamente. La
          versión vigente estará disponible en el sitio oficial de la
          aplicación.
        </p>
      </section>

      <section>
        <h2>10. Contacto</h2>

        <div class="contact">
          <p>
            Para consultas relacionadas con esta Política de Privacidad,
            comuníquese con el administrador de la aplicación:
          </p>

          <p>
            <strong>Email:</strong>
            raqueveque&#64;blister.com.ar
          </p>

          <p>
            <strong>Organización:</strong>
            Chevron IPCMS
          </p>
        </div>
      </section>
    </div>

    <footer class="footer">
      © 2026 Chevron IPCMS. Todos los derechos reservados.
    </footer>
  </main>
</div>
